import React, { useState, useEffect, useRef, useMemo } from "react";
import global from "../../global-variables";
import Header from "../layout/header";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { FaAngleLeft, FaSearch } from "react-icons/fa";
import $ from "jquery";
import WOW from "wowjs";
import { Container, Row, Col } from "reactstrap";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Form from 'react-bootstrap/Form';
import globalVariables from "../../global-variables";
import Metatag from "../../hooks/Metatag";
import Accordion from 'react-bootstrap/Accordion';
import Pagination from 'react-bootstrap/Pagination';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import axios from "axios";
import FacultyListForSearch from "../../Components/FacultyListForSearch";

export default function ResearchSearchResults() {

  const navigate = useNavigate();
  const { state } = useLocation();
  
  const [expanded, setExpanded] = useState(false);

  //get research paging from settings table
    const [resPaging,setResPaging] = useState(null);
        
        useEffect(()=>{
            let _obj =new Object();
            _obj.setting_id = globalVariables.variables.strSetting_id
            axios.post(globalVariables.variables.strApiUrl +'/settingApi/getCompanySettingList',_obj)
            .then((response)=>{
                  setResPaging(response.data[0][0].setting_res_paging)
    
            })
        },[])
        
    const itemsPerPage = resPaging; // Default to 10 if resPaging is null or undefined
  const [currentPage, setCurrentPage] = useState(1);

  const txtSearchRef = useRef(null);

  const handleSearch = () => {
    const searchValue = txtSearchRef.current.value.trim();
    if (!searchValue) {
        // Optionally show an error message
        return;
    }
    navigate('/research-projects/search-result', {
        state: {
            resStr: searchValue,
            facultyId: null,
            faculty_name: null,
            sdg_id: null,
            sdg_name: null,
            focusAreaId: null,
            focusAreaName: null,
        },
    });
    setFilterState((prev) => ({
      ...prev,
      resStr : searchValue,
      facultyId : null,
      sdg_id : null,
      faculty_name : null,
      sdg_name : null
  }))
    txtSearchRef.current.value = '';
    setCurrentPage(1);
    setExpanded(false);
    setSelectedFocusAreas([])
    setSelectedFocusAreasName([])
    setSelectedDepartment([])
    setSelectedDepartmentName([])
};

const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
        e.preventDefault(); // Prevent default form submission
        handleSearch();
    }
};

  // Filter states
  
  const [selectedDepartment, setSelectedDepartment] = useState([]);
  const [selectedDepartmentName, setSelectedDepartmentName] = useState([]);

  const [selectedFocusAreas, setSelectedFocusAreas] = useState(state?.focusAreaId !== null ? [state?.focusAreaId] : []);
  const [selectedFocusAreasName, setSelectedFocusAreasName] = useState(state?.focusAreaName !== null ? [state?.focusAreaName] : []);
  
  const [filterState , setFilterState] = useState({
                                        resStr :state?.resStr !== null ? state?.resStr : null ,
                                        facultyId :state?.facultyId !== null ? state?.facultyId : null,
                                        sdg_id :state?.sdg_id !== null ? state?.sdg_id : null,
                                        faculty_name :state?.faculty_name !== null ? state?.faculty_name : null,
                                        sdg_name :state?.sdg_name !== null ? state?.sdg_name : null,
                                        resType :state?.resType !== null ? state?.resType : null

                                      })
                                      
   // Handle department filter change
   const handleDepartmentChange = (event , department) => {
    const { id, checked } = event.target;
    setSelectedDepartment(prev => 
      checked ? [...prev, id] : prev.filter(dep => dep !== id)
    );
    setSelectedDepartmentName(prev => 
      checked ? [...prev, department.res_depart_name] : prev.filter(name => name !== department.res_depart_name ))

    setExpanded(false)

    //reset focusarea value
    setSelectedFocusAreas([])
    setSelectedFocusAreasName([])
    setFilterState((prev) => ({
      ...prev,
      resStr : null,
      facultyId : null,
      sdg_id : null,
      faculty_name : null,
      sdg_name : null
    }))

    //reset the current page
    setCurrentPage(1)
  };
  
  // Handle focus area filter change
  const handleFocusAreaChange = (event , focusArea) => {
    
    const { id, checked } = event.target;
    setSelectedFocusAreas(prev => 
      checked ? [...prev, id] : prev.filter(area => area !== id)
    );

    setSelectedFocusAreasName(prev => 
      checked ? [...prev, focusArea.focus_ar_name] : prev.filter(name => name !== focusArea.focus_ar_name ))

    setExpanded(false)

  //reset department value
    setSelectedDepartment([])
    setSelectedDepartmentName([])
    setFilterState((prev) => ({
      ...prev,
      resStr : null,
      facultyId : null,
      sdg_id : null,
      faculty_name : null,
      sdg_name : null
    }))

  //reset the current page
  setCurrentPage(1)
  };

  const [research, setResearch] = useState({
                              researchList : null,
                              researchDepartment : [],
                              researchFocusArea : []
                          });
  
  //get research list
  useEffect(() => {
    
    let _obj = new Object();
    _obj.res_status = 1;
    _obj.rtype_pagename = filterState?.rtype_pagename;
    _obj.departments = selectedDepartment;
    _obj.focus_areas = selectedFocusAreas;
    _obj.searchstr = filterState?.resStr; 
    _obj.res_faculty_id = filterState?.facultyId
    _obj.sdg_id = filterState?.sdg_id
    _obj.res_rtype_id = filterState?.resType;
    
    axios
      .post(
        globalVariables.variables.strApiUrl + "/researchApi/getresearchList",
        _obj
      )
      .then((response_researchList) => {
        if (response_researchList.data === "error") {
          navigate("/error-page");
        } else {
          setResearch((prev) => ({...prev , researchList: response_researchList.data[0]}));
        }
      });

  }, [selectedDepartment,
      selectedFocusAreas, 
      filterState.facultyId,
      filterState.resStr
    ]);

  useEffect(()=>{

    let _objDepartment = new Object();
		_objDepartment.rtype_id = null;

		axios.post(globalVariables.variables.strApiUrl + '/researchApi/getmapResearchDepartmenthavingResearch',_objDepartment)
			.then((response) => {
				setResearch((prev) => ({...prev , researchDepartment : response.data[0]}));
			});


    let _objFocusArea = new Object();
		_objFocusArea.rtype_id = null;

		axios.post(globalVariables.variables.strApiUrl + '/researchApi/getmapResearchFocusAreahavingResearch',_objFocusArea)
			.then((response) => {
				setResearch((prev) => ({...prev , researchFocusArea : response.data[0]}));
			});

  },[])


  // Determine the start and end item for the current page
  const startIndex = (currentPage - 1) * itemsPerPage + 1;
  const endIndex = Math.min(startIndex + itemsPerPage - 1, research.researchList?.length);
  
  
  // Calculate total pages
  const totalPages = Math.ceil(research.researchList?.length / itemsPerPage);
  
  // Determine the projects to display on the current page
  // const displayedProjects = research.researchList?.slice(
  //   (currentPage - 1) * itemsPerPage,
  //   currentPage * itemsPerPage
  // );
  
  const displayedProjects = useMemo(() => {
    return research.researchList?.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    );
  }, [research.researchList, currentPage, itemsPerPage]);
  
  //function to handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    // remove bg-header-home 
    $(window).on("scroll", function () {
      $(".navbar").offset().top > 10 ? $(".fixed-top").removeClass("bg-header-home") : $(".fixed-top").removeClass("bg-header-home")
    });

    // initiate the wow effect
    new WOW.WOW({
      live: false,
    }).init();
  }, [research ,currentPage])

  const [resFocusAreaList,setresFocusAreaList] = useState(null)

  useEffect(()=>{

    let _obj = new Object();
    //get focus area list
    axios.post(globalVariables.variables.strApiUrl + '/researchApi/getonlymappedResearchFocusAreaList',_obj)
    .then((response) => {
      setresFocusAreaList(response.data[0])
    });
  },[])

  
  // Create a hash map for focus area
  const focusAreaMap = useMemo(()=>{
    return resFocusAreaList && resFocusAreaList.reduce((map, focus_area) => {
      
      if (!map[focus_area.res_focus_ar_res_id]) {
        map[focus_area.res_focus_ar_res_id] = [];
      }
      map[focus_area.res_focus_ar_res_id].push(focus_area);
      return map;
    }, {});
  },[resFocusAreaList])

  return (
    <>
      <Header></Header>
      {/* MetaTag */}
      {
        state !== undefined ?
        <Metatag title={`Filter results`}
          description={`Filter results`}
          keywords={`Filter results`}
        /> 
        :''
      }
      

      {/* Visual Panel */}
      <Container fluid className="bg-visual-inside px-0" >
      <div className="visual-inside-big visual-container-inside">
          <Container>
            <Row className="g-md-0">
              <Col xs={8} md={12}>
                <div className="py-md-4">
                  <div className="d-inline-block m-0 align-self-end py-xl-3 p-2 text-white d-md-flex align-items-end wow fadeInUp">
                    {/* <h1 className="fw-light text-white m-0 align-self-center me-3">
                      Research |
                    </h1> */}
                    {
                      state !== null ? 
                    <div className="mb-1 gap-2">
                      {
                        ((filterState?.resStr !== null && displayedProjects?.length !== 0) || filterState?.faculty_name !== null || filterState?.sdg_name !== null || selectedFocusAreasName.length > 0 || selectedDepartmentName.length > 0) && (
                          <>
                          <b>Results for</b>{" "}
                          </>
                        )
                      }
                    {/* <b>Results for</b>{" "} */}
                    {(filterState?.resStr !== null || filterState?.faculty_name !== null || filterState?.sdg_name !== null || selectedFocusAreasName.length > 0 || selectedDepartmentName.length > 0) && (
                      // <div className="fw-normal mb-3">
                        <>
                          {filterState?.resStr !== null && displayedProjects?.length !== 0 && `'${filterState?.resStr}'`}
                          {/* {filterState?.resStr !== null && (filterState?.faculty_name || filterState?.sdg_name || selectedFocusAreasName.length > 0 || selectedDepartmentName.length > 0) && ' | '} */}
                          
                          {filterState?.faculty_name && `Faculty: ${filterState.faculty_name}`}
                          {/* {filterState?.faculty_name && (filterState?.sdg_name || selectedFocusAreasName.length > 0 || selectedDepartmentName.length > 0) && ' | '} */}
                          
                          {filterState?.sdg_name && `SDG: ${filterState.sdg_name}`}
                          {/* {filterState?.sdg_name && (selectedFocusAreasName.length > 0 || selectedDepartmentName.length > 0) && ' | '} */}
                          
                          {selectedFocusAreasName.length > 0 && (
                            <>
                              <span>Focus Area:</span> 
                              {selectedFocusAreasName.map((focus_Area, index) => (
                                <span key={index}> {focus_Area}{index < selectedFocusAreasName.length - 1 ? ',' : ''}</span>
                              ))}
                            </>
                          )}
                          {/* {selectedFocusAreasName.length > 0 && selectedDepartmentName.length > 0 && ' | '} */}
                          
                          {selectedDepartmentName.length > 0 && (
                            <>
                              <span>Department:</span>
                              {selectedDepartmentName.map((depart, index) => (
                                <span key={index}> {depart}{index < selectedDepartmentName.length - 1 ? ',' : ''}</span>
                              ))}
                            </>
                          )}
                          {filterState?.resStr !== null && displayedProjects?.length === 0  ? '' : <span> ({research.researchList ? research.researchList.length : '0'} Records found)</span>}
                        </>
                        
                      // </div>
                    )}

                    </div>
                    :
                    <div className="mb-1 d-flex gap-2"></div>
                    }
                  </div>
                </div>
              </Col>
              {/* <Col xs={4} md={6}>
                  <Button onClick={() => navigate(-1)} className="btn btn-primary rounded-pill Faicon px-3 py-1 ms-auto d-flex align-items-center wow fadeInUp">
                    <FaAngleLeft /> Back
                  </Button>
                </Col> */}
            </Row>
          </Container>
        </div>
      </Container>

      {/* Content Panel */}
      <Container className="my-5 position-relative">
        <Row className="g-4 gx-xl-5">
          <Col md={4} lg={3} className="z-1">
            <div className="bg-white h-100">
              <div className="border-bottom border-4 border-primary rounded-4 h-100">
                <div className="bg-primary bg-opacity-10 rounded-4 py-md-4 py-3 px-4 border h-100 filter">
                <Navbar expanded={expanded} collapseonselect expand="xl" className='d-block p-0'>
                  <Navbar.Toggle onClick={() => setExpanded(expanded ? false : "expanded")} className="offcanvas-toggle shadow-none px-1 d-flex fw-medium w-100 d-md-none d-block" aria-controls={'offcanvas-filtermenu'}>
                    <div className="me-3">
                      <span className="icon-bar"></span>
                      <span className="icon-bar"></span>
                      <span className="icon-bar"></span>
                    </div>
                    Filter Projects by
                  </Navbar.Toggle>

                  <Navbar.Offcanvas id={'offcanvas-filtermenu'} aria-labelledby={'offcanvas-filtermenu'} placement="start" responsive="md" className="px-md-0 px-4 mt-auto">
                    <Offcanvas.Header closeButton onClick={() => setExpanded(false)} className="px-0">
                      <Offcanvas.Title>
                      </Offcanvas.Title>
                    </Offcanvas.Header>
                    <div className="form-group mb-4">
                      <div className="input-group">
                        <input name="txtsearch"
                         type="text"
                          id="txtSearch"
                          ref={txtSearchRef}
                          className="form-control form-control-sm py-2 ps-3 pe-4 rounded-pill"
                          placeholder="Search"
                          onKeyDown={handleKeyDown}
                          />
                        <div className="search-btn">
                          <button id="researchBtn" className="researchBtn" onClick={handleSearch} ><FaSearch /></button>
                        </div>
                      </div>
                      {/* <span id="searcherrResearch" class="text-danger small mx-2"></span> */}
                    </div>
                    <h6 className="text-primary">Filter Projects by</h6>
                    <Accordion defaultActiveKey={['0', '1']} alwaysOpen>
                    
                      {
                        research.researchFocusArea.length > 0 ?
                        <Accordion.Item eventKey="1" className="filterheader">
                          <Accordion.Header className="p-0 border-bottom">Focus Areas</Accordion.Header>
                          <Accordion.Body className="border-0 px-1 pt-2">
                            <Form>
                              <div className="mb-3">
                              {research.researchFocusArea?.map((focusArea ,index) => (
                                  <Form.Check type={'checkbox'}
                                    id={focusArea.focus_ar_id}
                                    label={`${focusArea.focus_ar_name} (${focusArea.research_count})`}
                                    onChange={(event) => handleFocusAreaChange(event, focusArea)}
                                    key={index}
                                    checked={selectedFocusAreas.includes(focusArea.focus_ar_id)}
                                    className="mb-1"
                                     />
                                    ))}
                            </div>
                            </Form>
                          </Accordion.Body>
                        </Accordion.Item>
                        : 
                        null
                      }
                      {
                      research.researchFocusArea.length > 0 ?
                      <Accordion.Item eventKey="0" className="filterheader">
                        <Accordion.Header className="p-0 border-bottom">Department</Accordion.Header>
                        <Accordion.Body className="border-0 px-1 pt-2">
                          <Form>
                            <div className="mb-3">
                            {research.researchDepartment?.map((department ,index) => (
                                <Form.Check type={'checkbox'}
                                  id={department.res_depart_id}
                                  label={`${department.res_depart_name} (${department.res_dep_count})`}
                                  className="mb-1"
                                  key={index}
                                  onChange={(event) => handleDepartmentChange(event, department)}
                                  checked={selectedDepartment.includes(department.res_depart_id)}
                                   />
                                  ))}
                                  </div>
                          </Form>
                        </Accordion.Body>
                      </Accordion.Item>
                      : 
                      null
                    }
                    </Accordion>
                  </Navbar.Offcanvas>
                  </Navbar>
                </div>
              </div>
            </div>
          </Col>
          {
            research.researchList !== null ?
            <Col md={8} lg={9} className="projectslist">
              <div className="border rounded-4 p-lg-5 p-4 h-100">
                {
                displayedProjects.length > 0 ?
                  <div className="d-flex flex-column h-100">
                    {/* <div className="d-flex align-items-end mb-4 wow fadeInUp">
                      <h2 className="m-0 me-2 text-primary">Research Projects</h2> <small>Showing 1-5 of 15</small>
                    </div> */}
                    {displayedProjects?.map((project, index) => {
                    return (
                      <div key={index}>
                        <Row className="position-relative g-3 overflow-hidden">
                          {/* <Col md={6} lg={3} className="pe-lg-4">
                            <Link to={`${globalVariables.variables.strDomainUrl}research-projects/${project.rtype_pagename}/${project.res_pagename}`}>
                              <img
                                src={project.res_banner !== null && project.res_banner !== "" ? `${globalVariables.variables.strApiUrl}/research-banner/${project.res_banner}` : global.variables.strDomainUrl + "images/default-research-thumbnail.png"}
                                alt={project.res_title}
                                title={project.res_title}
                                className="img-fluid border rounded-2 bg-white wow fadeInUp"
                              />
                            </Link>
                          </Col> */}
                          <Col md={12} lg={12}>
                            <Link to={`${globalVariables.variables.strDomainUrl}research-projects/${project.rtype_pagename}/${project.res_pagename}`} className="text-decoration-none">
                              <h6 className="lh-base text-black mb-2 wow fadeInUp">
                                {project.res_title}
                              </h6>
                            </Link>
                            <ul className="list-group wow fadeInUp">
                               <FacultyListForSearch
                                res_id={project?.res_id}
                                setCurrentPage={setCurrentPage}
                                setSelectedFocusAreas={setSelectedFocusAreas}
                                setSelectedFocusAreasName={setSelectedFocusAreasName}
                                setSelectedDepartment={setSelectedDepartment}
                                setSelectedDepartmentName={setSelectedDepartmentName}
                                setFilterState={setFilterState}
                                />
                                {/* {
                                  project.res_focus_ar_json !== null ? (
                                  <li className="list-group-item border-0 px-0 py-1">
                                    <span className="text-black fw-medium">Focus Areas:</span>
                                    {
                                    JSON.parse(project.res_focus_ar_json).map((focusArea, i) => (
                                      <>
                                      <span key={i}>
                                        {" "}{focusArea.focus_ar_name}
                                      </span>
                                        {i < JSON.parse(project.res_focus_ar_json).length - 1 && ','}
                                      </>
                                    ))
                                    }
                                  </li>
                                  )
                                  :
                                  null
                                } */}
                                {
                                    resFocusAreaList !== null ? (
                                    <li className="list-group-item border-0 px-0 py-1">
                                      <span className="text-black fw-medium">Focus Areas:</span>
                                      {
                                      focusAreaMap[project?.res_id]?.map((focusArea, i) => (
                                        <>
                                        <span key={i}>
                                          {" "}{focusArea.focus_ar_name}
                                        </span>
                                          {i < focusAreaMap[project?.res_id]?.length - 1 && ','}
                                        </>
                                      ))
                                      }
                                    </li>
                                    )
                                    :
                                    null
                                  }
                            </ul>
                          </Col>
                        </Row>
                        {/* Only show <hr /> if not the last project in displayedProjects */}
                        {index < displayedProjects.length - 1 && <hr className="my-4" />}
                      </div>
                    );
                  })
                  }
                    {/* Pagination Controls */}
                    <Pagination className="mt-auto justify-content-center pt-4">
                      <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
                      {[...Array(totalPages).keys()].map((pageNumber) => (
                        <Pagination.Item
                          key={pageNumber + 1}
                          active={pageNumber + 1 === currentPage}
                          onClick={() => handlePageChange(pageNumber + 1)}
                        >
                          {pageNumber + 1}
                        </Pagination.Item>
                      ))}
                      <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
                    </Pagination>
                  </div>
                 :
                 <div>
                   <Row className="position-relative g-3 overflow-hidden">
                     <span className="text-start">Results for '{filterState?.resStr}' ({research.researchList.length} Records found)</span>
                   </Row>
                 </div>
                } 
              </div>
            </Col>
            :
            <Col md={8} lg={9} className="projectslist">
              <div className="border rounded-4 p-lg-5 p-4 h-100">
                <Row >
                  <span className="text-center">Loading...</span>
                </Row>
              </div>
            </Col>
          }
        </Row>
      </Container>

      {/* Breadcrumb */}
      <Breadcrumb className="breadcrumb-panel mt-auto">
        <Breadcrumb.Item href={globalVariables.variables.strDomainUrl}>Home</Breadcrumb.Item>
        <Breadcrumb.Item href={globalVariables.variables.strDomainUrl + 'research'}>Research</Breadcrumb.Item>
        <Breadcrumb.Item active>Search Result</Breadcrumb.Item>
      </Breadcrumb>
    </>
  );
}